module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": _vm.toggleText
    }
  }, [_c('p', {
    class: ['prelude', {
      offerMoreText: _vm.offerMoreText
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), (_vm.crop && _vm.expanded && _vm.text) ? _c('p', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-674a23a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/parts/content.vue
// module id = 159
// module chunks = 1